import { Button, Logo } from '@getinapp/appetizer';
import { LogOut } from '@styled-icons/boxicons-regular/LogOut';
import { UserCheck } from '@styled-icons/boxicons-regular/UserCheck';
import { UserCircle } from '@styled-icons/boxicons-regular/UserCircle';
import { DateRange } from '@styled-icons/material/DateRange';
import { useAuth } from 'hooks/use-auth';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import React from 'react';
import { Col, Container, Hidden, Row, Visible } from 'react-grid-system';
import { useTranslation } from 'react-i18next';
import {
  GET_IN_AUTH_TOKEN_COOKIE_KEY,
  GET_IN_USER_COOKIE_KEY,
} from 'utils/constants';
import { Event } from 'utils/helpers';
import * as S from './styles';

export const Footer = () => {
  const { setAuthUser, user } = useAuth();
  const { t } = useTranslation();
  const router = useRouter();
  const year = new Date().getFullYear();

  const redirectToHomePage = () => router.push('/');

  const navs = [
    {
      title: 'Início',
      onClick: () => router.push('/'),
    },
    {
      title: 'Tipos de Cozinha',
      onClick: () => router.push('/categories'),
    },
    {
      title: 'Dúvidas Frequentes',
      onClick: () => router.push('/faq'),
    },
  ];

  const handleLogout = () => {
    Event.push('getin_profile_logout_entered', {
      user_id: user?.id,
    });

    Cookies.remove(GET_IN_USER_COOKIE_KEY);
    Cookies.remove(GET_IN_AUTH_TOKEN_COOKIE_KEY);
    setAuthUser(null);
    router.reload();
  };

  const authNavs = [
    {
      title: 'Minhas Reservas',
      onClick: () => router.push('/my-reservations'),
      icon: <DateRange size={25} />,
    },
    {
      title: 'Minha Posição na Fila',
      onClick: () => router.push('/my-position'),
      icon: <UserCheck size={25} />,
    },
    {
      title: 'Meu perfil',
      onClick: () => router.push('/profile'),
      icon: <UserCircle size={25} />,
    },

    {
      title: 'Sair',
      onClick: () => handleLogout(),
      icon: <LogOut size={25} />,
    },
  ];

  return (
    <S.Container id="footer">
      <Container fluid style={{ width: '100%' }}>
        <Row gutterWidth={15}>
          <Col lg={3} sm={12} xs={12}>
            <div className="centralized-container">
              <span className="logo-wrapper" onClick={redirectToHomePage}>
                <Logo size="small" />
              </span>
              <div className="made-with-love">
                <span>{t('@Footer.made-with-love')}</span>
              </div>
              <div className="privacy-terms">
                <span>
                  <a
                    href={t('@PrivacyAndTerms.terms-of-use-link')}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('@Footer.terms-of-use')}
                  </a>
                  &nbsp; {t('@Footer.and')} &nbsp;
                  <a
                    href={t('@PrivacyAndTerms.privacy-policy-link')}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('@Footer.privacy-policy')}
                  </a>
                </span>
              </div>
            </div>
          </Col>
          <Visible xs sm>
            <Col sm={12} xs={12}>
              <br />
              <S.ContainerTitle>
                <label>Navegue</label>
              </S.ContainerTitle>
              <ul>
                {navs.map((nav) => (
                  <li key={nav.title} onClick={nav.onClick}>
                    {nav.title}
                  </li>
                ))}
              </ul>
              {user && (
                <>
                  <br />
                  <S.ContainerTitle>
                    <label>Meus dados</label>
                  </S.ContainerTitle>
                  <ul>
                    {authNavs.map((nav) => (
                      <li key={nav.title} onClick={nav.onClick}>
                        <span>{nav.icon}</span>
                        {nav.title}
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </Col>
          </Visible>
          <Visible xs sm>
            <S.Divider />
          </Visible>
          <Col lg={3} sm={12} xs={12}>
            <S.ContainerTitle>
              <label>Precisa de ajuda com sua reserva?</label>
            </S.ContainerTitle>
            <br />
            <Visible xs sm>
              <Button
                variant="outline"
                size="regular"
                isFullWidth
                onClick={() => router.push('/faq')}
              >
                Dúvidas Frequentes
              </Button>
            </Visible>
            <Hidden xs sm>
              <Button
                variant="outline"
                size="small"
                onClick={() => router.push('/faq')}
              >
                Dúvidas Frequentes
              </Button>
            </Hidden>
          </Col>
          <Visible xs sm>
            <S.Divider />
          </Visible>
          <Col lg={6} sm={12} xs={12}>
            <S.ContainerTitle>
              <label>
                É dono de um estabelecimento e quer falar com a gente?
              </label>
            </S.ContainerTitle>
            <br />
            <Visible xs sm>
              <Button
                variant="outline"
                size="regular"
                isFullWidth
                onClick={() =>
                  window.open('https://restaurante.getinapp.com.br', '__blank')
                }
              >
                Conheça as soluções Get In
              </Button>
            </Visible>
            <Hidden xs sm>
              <Button
                variant="outline"
                size="small"
                onClick={() =>
                  window.open('https://restaurante.getinapp.com.br', '__blank')
                }
              >
                Conheça as soluções Get In
              </Button>
            </Hidden>
          </Col>
        </Row>
        <Row gutterWidth={15}>
          <Col lg={12} sm={12} xs={12}>
            <div className="copyright">
              <span>{t('@Footer.copyright', { year })}</span>
            </div>
          </Col>
        </Row>
      </Container>
    </S.Container>
  );
};
